export default {
    computed: {
        nutritionComponents() {
            return this.$store.state.PublicMenuModule.nutrition || [];
        },
    },
    methods: {
        getImageUrl(item) {
            const imageUrl = item.ImageUrl || '/images/no-photo-available.jpg';
            return `background-image: url('${imageUrl}')`;
        },
        getTags(item) {
            return item.Tags || [];
        },
        getAllergens(item) {
            if (!item.Allergens || !Array.isArray(item.Allergens)) return null;
            return item.Allergens.map((allergenId) => this.$store.state.PublicMenuModule.allergens.find((a) => a.AllergenId === allergenId)).filter(Boolean);
        },
        getCustomAllergens(item) {
            return item.CustomAllergens;
        },
        getAllAllergensForLabel(item) {
            const standardAllergens = this.getAllergens(item);
            const customAllergens = this.getCustomAllergens(item);
            
            if (standardAllergens == null && customAllergens == null) return 'Not set by District';
            
            const standardNames = standardAllergens ? standardAllergens.map(a => a.AllergenName) : [];
            const customNames = customAllergens || [];
            const allAllergens = [...standardNames, ...customNames];
            
            if (allAllergens.length === 0) return 'None';
            return allAllergens.join(', ');
        },
        getNutrition(item) {
            if (!item.NutritionAmounts) return [];
            return this.nutritionComponents
                .filter((n) => item.NutritionAmounts[n.NutritionComponentId] && item.NutritionAmounts[n.NutritionComponentId].AmountF)
                .map((n) => {
                    const na = item.NutritionAmounts[n.NutritionComponentId];
                    return {
                        ...n,
                        ShortName: n.ShortName === 'Calories' ? '' : n.ShortName,
                        Amount: `${na.AmountF}${n.ShortName === 'Calories' ? ' ' : ''}${na.Unit}`,
                    };
                })
                .slice(0, 4);
        },
        onMore() {
            const slug = this.$route.params.districtSlug;
            this.$router.push(`/${slug}/nutrition-allergen`);
        },
    },
};
